// extracted by mini-css-extract-plugin
module.exports = {"root":"CreateCustomerListDialogue_root___yt_m","modal":"CreateCustomerListDialogue_modal__o5T7a"};